<template>
<div id="book-page-wrapper" >
      <div ref="loader" id="text-loader" class="loader"><img src="@/assets/icons/stoffe-loader.gif" /></div>
       
      <!--<button  @click="textImageIsShowing = true">Turn on overlay effect</button>-->
      <div id="imageoverlay" v-show="$store.state.navStates.isTextImageShowing" >
        <span id="imageoverlay-closer" @click="closeImageOverlay"><span id="viewer-closer"></span></span>
        <!--<Viewer  ref="textimagetviewer" />-->
        <BookViewer  ref="textimagetviewer" />
      </div>

      <div id="book-infowindow" ref="infowindow">
          <div id="infowindow-closer"> &#215;</div>
          <div id="infowindow-text"></div>
      </div>
      <div id="footnote-infowindow">
        <div id="footnote-infowindow-closer">&#215;
        </div>
        <div id="footnote-infowindow-text"></div>
      </div>
      <span id="tooltip-span"></span>

    <div id="text-container" ref="textcontainer" v-html="$store.state.bookText" v-show="isReady" v-cloak></div>

  </div>
</template>
<script>
import {bookClickEventHandler} from "@/components/Scripts/bookClickEventHandler"
import BookViewer from "@/components/BookViewer"
import axios from 'axios'

export default {    
  name: 'BookContainer',
  components: {
    BookViewer
  }, 
  props: {
   // callFromRegister: Boolean,
    msg: String
  },
  data: function() {
      return {          
        textImageIsShowing: false,
        query: "Bd.", 
        isReady: true

        //text: 'ggggg'        
      }
  },
  watch: {

        '$store.state.textIsReady': function() {
            this.isReady = this.$store.state.textIsReady
        },

      $route(to, from) {    
          
          if (from.name.includes("text") && !to.name.includes("text")){
            this.$refs.textcontainer.style.opacity = 0
          }
      }
  },
  methods: {
      closeImageOverlay: function() {
        this.$store.commit('showTextImage', false)
      },
      bookClickEventHandler 
  },

  mounted() {  

   // if back button is pressed
   //window.onpopstate = function(event) {
   //  alert(" Browser Back button was clicked location: " + document.location + ", state: " + JSON.stringify(event.state));
   //};
   
  const textcontainer = document.getElementById('book-page-wrapper')     
  //textcontainer.removeEventListener('click', this.bookClickEventHandler);
  textcontainer.addEventListener('click', this.bookClickEventHandler, false )


  const baseURI = '/';           
  axios.get(baseURI + "book_start.html")
    .then((result) => {
        // close MainNav if open
        this.$store.commit('toggleMainNavState', false )
        this.$store.commit('updateBooktext', result.data)

    })        
  } 

}
</script>

<style lang="scss" >


[v-cloak] {display: none}



</style>